nativeErrorToString